import AxiosInstance from "./api";

export const AccountingStatement3Service = {
  create: (payload) => AxiosInstance.post("/private/accounting-statement-3", payload),
  update: (id, payload) => AxiosInstance.put(`/private/accounting-statement-3/${id}`, payload),
  delete: (id) => AxiosInstance.delete(`/private/accounting-statement-3/${id}`),
  findAll: (params) => AxiosInstance.get("/private/accounting-statement-3", { params }),
  findById: (id) => AxiosInstance.get(`/private/accounting-statement-3/${id}`),
  preview: (params) => AxiosInstance.get("/private/accounting-statement-3/sync/preview", { params }),
};
